import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';

const PSaleOrderEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [Quantity, setQuantity] = useState("");

    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        fetchItemData();
    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState({
        CompanyId: '',
        InvoiceDate: '',
        InvoiceTime: '',
        InvoiceNumber: '',
        TableId: '',
        SaleOrderId: '',
        Amount: '',
        DiscountAmount: '',
        DiscountPer: '',
        NetAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        RoundOff: '',
        TotalAmount: '',
        PaymentType: '',
        FinYear: '',
        isSubmit: false,
        TableText: '',
        ModifiedBy: userId,
        PreviousTotalAmount: '',
    });
    const [itemdata, setData] = useState([]);


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };
    const formatTimeForInput = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        fetchData('SaleApi', `/SaleDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setData(response.response_data.SaleDetails);
                }

                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));
               
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;

        if (name === 'DiscountPer') {
            const discountPercentage = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                DiscountPer: discountPercentage.toFixed(2),
                ModifiedBy: userId,
            }));


            // Calculate discount and other values for each item in itemdata
            const updatedItemData = itemdata.map((item) => {
                const amount = parseFloat(item.Amount) || 0;
                const discountAmount = (amount * discountPercentage) / 100;
                const netAmount = (amount - discountAmount).toFixed(2);
                const totalAmount = (parseFloat(netAmount)).toFixed(2);

                return {
                    ...item,
                    DiscountPer: discountPercentage.toFixed(2),
                    DiscountAmount: discountAmount.toFixed(2),
                    NetAmount: netAmount,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    TotalAmount: totalAmount,
                };
            });

            setData(updatedItemData);


            // Update the totals based on the updatedItemData
            const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, discAmount);

        } else if (name === 'DiscountAmount') {

            const discountAmount = parseFloat(value) || 0;
            const amount = parseFloat(formData.Amount) || 0;
            const discountPercentage = ((discountAmount / amount) * 100).toFixed(2);

            setFormData((prevData) => ({
                ...prevData,
                DiscountPer: discountPercentage,
                DiscountAmount: discountAmount,
                ModifiedBy: userId,
            }));

            // Calculate discount and other values for each item in itemdata
            const updatedItemData = itemdata.map((item) => {
                const amount = parseFloat(item.Amount) || 0;
                const discountAmount = (amount * discountPercentage) / 100;
                const netAmount = (amount - discountAmount).toFixed(2);
                const totalAmount = (parseFloat(netAmount)).toFixed(2);

                return {
                    ...item,
                    DiscountPer: discountPercentage,
                    DiscountAmount: discountAmount.toFixed(2),
                    NetAmount: netAmount,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    TotalAmount: totalAmount,
                };
            });

            setData(updatedItemData);


            // Update the totals based on the updatedItemData
            const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            //const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, discountAmount);

        }
        else {
            // Update other fields as usual
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? !prevData[name] : value,
            }));
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();


        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: itemdata
        };

        // Validate form data here if needed

        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/SaleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...itemdata];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setData(updatedRecords); // Update the state to reflect the removed record 

            let invAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            let netAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            let discAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, discAmount);
        }

    };

    const totalCalculation = (invAmount, netAmount, discAmount) => {
        let amount = parseFloat(invAmount);
        let netamount = parseFloat(netAmount);
        let netAmt = netAmount;
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmount = (netAmt + roundOffValue).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            Amount: amount.toFixed(2),
            NetAmount: netamount.toFixed(2),
            TotalAmount: totalAmount,
            DiscountAmount: discAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            CGSTAmount: 0,
            SGSTAmount: 0,
            IGSTAmount: 0,
            ModifiedBy: userId,
        }));
    };

    const handleCalculation = (e, index) => {
        const { name, value } = e.target;
        const discountPercentage = parseFloat(formData.DiscountPer) || 0;

        const updatedItemData = itemdata.map((item, i) => {
            if (i === index) {
                if (name === 'Quantity') {
                    const quantity = parseFloat(value) || 0;
                    const rate = parseFloat(item.Rate) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    const totalAmount = (parseFloat(netAmount)).toFixed(2);

                    return {
                        ...item,
                        Quantity: quantity,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        TotalAmount: totalAmount,
                    };
                } else if (name === 'Rate') {
                    const rate = parseFloat(value) || 0;
                    const quantity = parseFloat(item.Quantity) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    const totalAmount = (parseFloat(netAmount)).toFixed(2);

                    return {
                        ...item,
                        Rate: rate,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        TotalAmount: totalAmount,
                    };
                }
            }
            return item;
        });

        setData(updatedItemData);

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const discAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

        totalCalculation(invAmount, netAmount, discAmount);
    };



    //Items

    const [selecteditems, setSelectedItems] = useState("");
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItemsType, setSelectedItemsType] = useState("");

    const fetchItems = async () => {
        try {
            const response = await fetchData('DespatchReport', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setItemsrOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleItemsChange = (selectedOption) => {
        setSelectedItemsType(selectedOption);
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const fetchItemData = async () => {
        try {
            const response = await fetchData('SaleApi', `/SaleDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data.Sale);
                setData(response.response_data.SaleDetails);
            }
        } catch (error) {
            console.error('Error fetching Item', error);
        }
    };


    const addRecord = async (e) => {
        e.preventDefault();
    
        if (!Quantity) {
            setErrorMessage("All fields are required!");
            return;
        }
    
        const updateRecord = {
            Id : id,
            SaleOrderId : id,
            CustomerId :formData.CustomerId,
            Quantity: Quantity,
            ItemId: selectedItemsType.value,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };
    
        try {
            const response = await updateData('DespatchReport', id, updateRecord, token);
            console.log('Record updated successfully:', response);
            
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            setQuantity("");
            setSelectedItemsType("");
        
            fetchItemData();
            setIsModalOpen(true);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };
    

   

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">

                <style>
                    {`
        .radio-group label {
            display: inline-block;
            margin-right: 10px;
        }
        
        .radio-group input {
            transform: scale(1.5); 
            margin-right: 5px;
            margin-top:10px;
        }
    
    `}
                </style>
                <form onSubmit={handleSubmit}>
                    <div className="w-full mb-2 flex">
                        <h3 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> SaleOrder - Edit</h3>


                        <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={toggleModal} style={{ backgroundColor: 'yellowgreen' }}>
                            Add Record
                        </Button>


                        <Button
                            variant="contained"
                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            onClick={handleSubmit}
                        >
                            UPDATE
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/PROBilledIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            CANCEL
                        </Button>
                    </div>


                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="flex">
                        <div className="w-1/2 pr-4">
                            <div className="bg-blue-800 rounded-lg shadow-lg p-6">
                                <div className="w-full mb-4 flex">

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Invoice No : <strong>{formData.OrderNo}</strong>

                                        </label>

                                    </div>
                                    <div className="w-1/7 mr-3" style={{ marginLeft: '50px' }}>
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Invoice Date : <strong>{formatDateForInput(formData.OrderDate)}</strong>

                                        </label>

                                    </div>

                                </div>
                                <div className="w-full mb-4 flex">

                                    <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate" style={{ marginTop: '15px' }}>
                                        Customer
                                    </label>
                                    <input style={{ margin: '10px' }}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CustomerName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Enter CustomerName"
                                        readOnly

                                    />


                                </div>
                                <div className="w-full mb-1 flex">
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Amount

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.Amount).toFixed(2)}
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Amount"
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Discount %

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.DiscountPer).toFixed(2)}
                                            onChange={handleChange}
                                            name='DiscountPer'
                                            type="number"
                                            placeholder="Enter Discount %"
                                        />
                                    </div>
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Discount Amount

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.DiscountAmount).toFixed(2)}
                                            onChange={handleChange}
                                            name='DiscountAmount'
                                            type="number"
                                            placeholder="Enter Discount Amount"
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className="w-full mb-1 flex">
                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Net Amount

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.NetAmount).toFixed(2)}
                                            name='NetAmount'
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Net Amount"
                                            readOnly
                                        />
                                    </div>


                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Round Off

                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.Roundoff).toFixed(2)}
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Round Off"
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/7 mr-3">
                                        <label className="block tracking-wide text-white text-base font-medium mb-2" htmlFor="rate">
                                            Total Amount
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                            value={Number(formData.TotalAmount).toFixed(2)}
                                            onChange={handleChange}
                                            type="number"
                                            placeholder="Enter Total Amount"
                                            readOnly
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="w-1/2 pl-4">
                            <div className="bg-teal-700 rounded-lg shadow-lg p-6">
                                <div className="w-full mb-4 flex">
                                    <div className="w-full mb-4 flex">
                                        <TableContainer component={Paper}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th style={{ padding: '8px' }}>Item Name</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Quantity</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Rate</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Disc %</th>
                                                        <th style={{ padding: '8px', textAlign: 'center' }}>Total</th>
                                                        <th style={{ padding: '8px' }}>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {itemdata.map((invdetail, index) => (
                                                        <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                            <td style={{ padding: '8px', fontSize: '14px', width: '45%' }}>{invdetail.Item}</td>
                                                            <td style={{ padding: '1px', fontSize: '14px', width: '10%', textAlign: 'center', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                                <input
                                                                    type="number"
                                                                    value={invdetail.Quantity}
                                                                    onChange={(e) => handleCalculation(e, index)}
                                                                    style={{ maxWidth: '120px', textAlign: 'right' }}
                                                                    name="Quantity"
                                                                />

                                                            </td>
                                                            <td style={{ padding: '8px', fontSize: '14px', width: '15%', textAlign: 'center' }}>{invdetail.Rate}</td>
                                                            <td style={{ padding: '8px', fontSize: '14px', width: '15%', textAlign: 'center' }}>{invdetail.DiscountPer}</td>
                                                            <td style={{ padding: '8px', fontSize: '14px', width: '15%', textAlign: 'center' }}>{invdetail.TotalAmount}</td>
                                                            <td style={{ padding: '8px', marginTop: '-15px', width: '15%' }}>

                                                                {/* {hasDeleteTransactionPermission && ( */}
                                                                <IconButton style={{ padding: '8px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                                {/* )} */}

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isModalOpen && (
                        <div className="fixed inset-0 flex items-center justify-center z-10">
                            <div className="bg-gray-700 p-6 rounded-lg shadow-lg" style={{ width: '700px' }}>

                                <h4 style={{ textAlign: 'center',color:'white' }}>ADD ITEMS </h4>
                                <br></br>
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/2 mr-2">
                                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="Weightage">
                                            ItemName
                                        </label>
                                        <Select
                                            value={selectedItemsType}
                                            onChange={handleItemsChange}
                                            options={itemsOptions}
                                            placeholder="Items"
                                            isSearchable
                                        />
                                    </div>

                                    <div className="w-1/10 mr-2">
                                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="MinimumStock">
                                            Quantity
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                            type="text"
                                            name="Quantity"
                                            placeholder="Enter Quantity"
                                            value={Quantity}
                                            onChange={(e) => setQuantity(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* end here */}
                                <div className="w-1/2 mr-4" style={{ marginTop: '23px' , marginLeft:'200px'}}>
                                    <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                        Add Record
                                    </button>
                                    <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}


                </form>
            </div >
        </Fragment >

    );
};

export default PSaleOrderEdit;
